export const DAYS_OF_WEEK = [
  { value: 'monday', label: 'Mon', fullLabel: 'Monday' },
  { value: 'tuesday', label: 'Tue', fullLabel: 'Tuesday' },
  { value: 'wednesday', label: 'Wed', fullLabel: 'Wednesday' },
  { value: 'thursday', label: 'Thu', fullLabel: 'Thursday' },
  { value: 'friday', label: 'Fri', fullLabel: 'Friday' },
  { value: 'saturday', label: 'Sat', fullLabel: 'Saturday' },
];

export const TIME_SLOTS = [
  {
    value: 'late-morning',
    label: 'Late Morning',
    range: '10:30 AM to 12:30 PM',
  },
  { value: 'early-afternoon', label: 'Early Afternoon', range: '1 to 3 PM' },
  {
    value: 'late-afternoon',
    label: 'Late Afternoon',
    range: '3:30 to 5:30 PM',
  },
  { value: 'evening', label: 'Evening', range: '6 to 8 PM' },
];